import { PayableInvoice } from "../../api/queries";

/**
 * Sum amounts per currency.
 *
 * Deliberately not one figure: an org can receive shekel and dollar invoices
 * in the same month, and adding those together would show a number that is
 * simply wrong. Rows without an amount (extraction pending or failed) are
 * skipped rather than counted as zero.
 */
export const totalsByCurrency = (
  invoices: PayableInvoice[],
): [string, number][] => {
  const totals = new Map<string, number>();

  invoices.forEach((invoice) => {
    if (invoice.amount === null) return;
    const currency = invoice.currency ?? "";
    totals.set(currency, (totals.get(currency) ?? 0) + invoice.amount);
  });

  return [...totals.entries()];
};
